import React from "react";
import { Button } from "antd";

const CustomButton = ({ type, className, children, ...otherProps }) => {
  const disabledButtonClass =
    "disabled:!bg-gray-100 disabled:border-gray-300 disabled:text-gray-300 disabled:cursor-not-allowed transition duration-150";
  const getButtonStyles = () => {
    switch (type) {
      case "tertiary":
        return "text-white bg-tertiary hover:text-white hover:bg-opacity-70 disabled:cursor-not-allowed";
      case "secondary":
        return "text-white bg-secondary hover:text-white hover:bg-opacity-70 disabled:cursor-not-allowed";
      case "primary":
        return "text-white bg-primary hover:text-white hover:bg-opacity-70 disabled:cursor-not-allowed";
      default:
        return "";
    }
  };

  return (
    <Button
      className={`${className} ${getButtonStyles()}`}
      type={type || "default"}
      {...otherProps}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
